// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1xet9","title":"AfterFrontImage_title__2Rs_O"};